// mode shifts user login
export enum SignInMode {
    Upload = 'upload',
    AddToCart = 'add_to_cart',
}
